export default __webpack_public_path__ + "static/media/LOA_NEWDAY_NEW.098fdc36.pdf";